/**
 * Enable disabled form button
 */

const $ = jQuery;

const enableBtn = () => {
    $('document').ready(function () {
        const submitBtn = document.querySelectorAll('input[type="submit"]');

        if (submitBtn) {
            Array.from(submitBtn).forEach(btn => {
                setTimeout(()=> {
                    btn.disabled = false;
                }, 1500);
            })
        }
    });
}

export { enableBtn };